import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./cfet-screens/cfet-screens.module').then(m => m.CfetScreensModule)
    }
];
